import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import Profile from "../assets/Profile.jpeg";
import NoImage from "../assets/NoImage.png";
import Cover from "../assets/Cover.png";

const MovieDetails = () => {
  const [movie, setMovie] = useState([]);
  const [Testing, setTesting] = useState([]);
  var { home_id } = useParams();

  useEffect(() => {
    axios
      .get(
        `
        https://api.themoviedb.org/3/movie/${home_id}?api_key=864351c4983b669ad95578b475142944&language=en-US&page=1`
      )
      .then((res) => {
        if (!res.data.poster_path) {
          res.data.poster_path = Cover
        } else {
          res.data.poster_path = "https://image.tmdb.org/t/p/original/" + res.data.poster_path
        }
        if (!res.data.backdrop_path) {
          res.data.backdrop_path = NoImage
        } else {
          res.data.backdrop_path = "https://image.tmdb.org/t/p/original/" + res.data.backdrop_path
        }
        const modifiedData = {
          id: res.data.id,
          title: res.data.title,
          vote_average: res.data.vote_average.toFixed(1),
          overview: res.data.overview,
          release_date: res.data.release_date,
          poster_path: res.data.poster_path,
          backdrop_path: res.data.backdrop_path,
          budget: res.data.budget,
          revenue: res.data.revenue,
        };
        setMovie(modifiedData);
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        `
      https://api.themoviedb.org/3/movie/${home_id}/credits?api_key=864351c4983b669ad95578b475142944&language=en-US`
      )
      .then((res) => {
        setTesting(res.data.cast.slice(0, 8));
        console.log(res.data.cast);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const setVoteClass = (vote) => {
    if (vote >= 8) {
      return "green";
    } else if (vote >= 6) {
      return "orange";
    } else {
      return "red";
    }
  };

  var options = { style: "currency", currency: "USD" };

  return (
    <div className="">
      <div className="movie-wrapper">
        <div className="single-cover">
            <img
              className="img-fluid backdrop-image"
              src={movie.poster_path}
              alt={movie.title}
            ></img>
        </div>
        <div className="single-backdrop">
            <img
              className="img-fluid backdrop-image"
              src={movie.backdrop_path}
              alt={movie.title}
            ></img>
        </div>
        <div className="movie-info">
          <p className="font-weight-bold single-title font-italic">
            {movie.title}
            <span className={`vote-color ${setVoteClass(movie.vote_average)}`}>
              {movie.vote_average}
            </span>
          </p>
          <div>
            <p className="overview">{movie.overview}</p>
            <div className="budget-revenue">
              <p className="budget">
                Budget:{" "}
                <span className="font-italic">
                  {movie.budget > 0
                    ? new Intl.NumberFormat("en-US", options)
                        .format(movie.budget)
                        .replace(/(\.|,)00$/g, "")
                    : "Not available"}
                </span>{" "}
              </p>
              <p>
                Revenue:{" "}
                <span className="font-italic">
                  {movie.revenue > 0
                    ? new Intl.NumberFormat("en-US", options)
                        .format(movie.revenue)
                        .replace(/(\.|,)00$/g, "")
                    : "Not available"}
                </span>
              </p>
            </div>
            <p className="mb-0">
              Released Date:{" "}
              <span className="font-italic">
                {moment(movie.release_date).format("MM/DD/YY")}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="cast card-group">
          {Testing.map((people) => (
            <div key={people.id} className="movie-star">
              {people.profile_path ? (
                <img
                  className="cast-image "
                  src={`https://image.tmdb.org/t/p/w200` + people.profile_path}
                  alt="cast"
                />
              ) : (
                <img className="cast-image" src={Profile} alt="cast" />
              )}
              <div className="cast-info">
                <p className="cast-name font-italic">{people.name}</p>
                <p className="cast-character">{people.character}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default MovieDetails;
